import React, { useContext } from 'react'
import { useHistory } from 'react-router-dom'
import { LocaleContext } from '../routes'
import { SeasonEndTime } from '../styles/season'
import {
  PlanetDescription, StarsDescription, PlanetTitle, PlanetState, StarsText, FlexRow
} from '../styles/planet'
import {
  MainHeader, MainHeaderBottom,
  CurrentPosition, Stars, MainHeaderContainer, TiersBtn
} from '../styles/home'
import Image, { PlanetImage } from '../styles/image'
import LeftIcon from '../assets/icons/left.svg'
import Score from './Score'
import { LabelExtra } from '../styles/elements'
import Header from './common/Header'
import { StarHeaderBottom, StarIcon } from '../styles/stars'

export default ({ title, planetType, point, goHome, backgroundImage, tiers }) => {
  const locale = useContext(LocaleContext)
  const history = useHistory()
  const gotoToStars = () => history.push('/stars')
  const gotoToTires = () => history.push('/tires')
  const planetName = planetType && planetType.toLowerCase()

  return (
    <MainHeader backgroundImage={backgroundImage}>
      <Header onBack={goHome} hasHelpButton />
      {title &&
        <MainHeaderBottom>
          <SeasonEndTime>
            {locale.SEASON_END_TIME} {title.split(' ')[0]}
          </SeasonEndTime>
          <MainHeaderContainer>
            <CurrentPosition>
              <PlanetImage
                alt={locale[planetType]}
                src={planetType && require(`../planets/${planetName}.png`)}
              />
              <PlanetDescription>
                <FlexRow>
                  <PlanetState>{locale.CURRENT_POSITION}:</PlanetState>
                  <PlanetTitle header>{locale[planetType]}</PlanetTitle>
                </FlexRow>
                <TiersBtn onClick={gotoToTires}>
                  {locale.VIEW_LEVELS}
                  <Image
                    margin="0 5px"
                    width="15px"
                    alt={locale.VIEW_LEVELS}
                    src={LeftIcon}
                    isLink
                  />
                </TiersBtn>
              </PlanetDescription>
            </CurrentPosition>
            <Stars onClick={gotoToStars}>
              <StarsDescription>
                <Score status="home">{point}</Score>
                <StarsText>{locale.STARS}</StarsText>
              </StarsDescription>
              <Image
                width="15px"
                alt={locale.STARS}
                src={LeftIcon}
                isLink
              />
            </Stars>
          </MainHeaderContainer>
        </MainHeaderBottom>
      }
      {!title &&
        <StarHeaderBottom>
          <StarIcon alt="*" src={require('../assets/icons/star.svg')} big />
          <LabelExtra fontSize="28px" bold padding="12px 0 0">{point}</LabelExtra>
          <LabelExtra fontSize="10px" light>{locale.STAR}</LabelExtra>
        </StarHeaderBottom>
      }
    </MainHeader>
  )
}